import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rd-drawer__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "rd-drawer__header"
}
const _hoisted_3 = {
  key: 0,
  class: "rd-drawer__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.display)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "drawer",
          class: _normalizeClass(["rd-drawer", [`rd-drawer--${_ctx.placement}`, _ctx.display ? 'rd-drawer--active' : '']])
        }, [
          (_ctx.displayHeader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.closeable)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn btn-default btn-link",
                      style: {"margin-left":"auto"},
                      onClick: _cache[0] || (_cache[0] = 
            () => {
              _ctx.$emit('close');
            }
          )
                    }, " Close "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.mask)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["rd-drawer__mask", { 'rd-drawer__mask--active': _ctx.display }]),
          onClick: _cache[1] || (_cache[1] = 
        () => {
          _ctx.$emit('close');
        }
      )
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}